<template>
  <div>
    <b-form @submit="selectDocuments">
      <b-row>
        <b-col>
          <b-form-group label-align="right" :label="$t('Reason of creation')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select v-model="selected" :options="listOfReasons">
              <template slot="first">
                <option :value="null">{{ $t('Load from file') }}</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-align="right" :disabled="selected !== null" :label="$t('File')" enctype="multipart/form-data" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-file :placeholder="$t('Choose a file...')" accept=".odt, .pdf" v-model="file" required/>
          </b-form-group>
          <b-form-group label-align="right" :disabled="selected !== null" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="name" required/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="success" style="float: right ;width: 100px" type="submit">{{ $t('Save') }}</b-button>
        </b-col>
        <b-col sm="3">
          <b-button variant="secondary" style="float: right ;width: 100px" @click="hideSelectDocuments">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axiosInstance from '@/utils/api.js'

export default {
  props: {
    currentRow: null
  },
  data () {
    return {
      newContract: {
        'user_id': '',
        'template_id': ''
      },
      listOfReasons: [],
      selected: null,
      file: null,
      name: ''
    }
  },
  methods: {
    hideSelectDocuments () {
      this.$emit('hideSelectDocuments')
    },
    selectDocuments (event) {
      event.preventDefault()
      if (this.selected === null) {
        var reader = new FileReader()
        reader.onload = (event) => {
          var contents = event.target.result
          axiosInstance.post(this.$store.getters.API_USERS_CONTRACTS_UPLOAD + '?user_id=' + this.currentRow.user_id + '&name=' + this.name, contents).then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              this.$emit('refreshTable')
              this.$root.$emit('makeToasts')
            }
          })
        }
        reader.onerror = function (event) {
          console.error('Файл не может быть прочитан! код ' + event.target.error.code)
        }
        reader.readAsArrayBuffer(this.file)
      } else {
        this.newContract.user_id = this.currentRow.user_id
        this.newContract.template_id = this.selected
        axiosInstance.post(this.$store.getters.API_USERS_CONTRACTS, this.newContract).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$emit('refreshTable')
            this.$root.$emit('makeToasts')
          }
        })
      }
    }
  },
  async mounted () {
    this.listOfReasons = await axiosInstance.get(this.$store.getters.API_SETTINGS_DOCUMENTS_TEMPLATES).then(response => { return response.data })
    this.listOfReasons = this.listOfReasons.filter(function (value) {
      return Number(value.type) === 6
    })
    for (let i in this.listOfReasons) {
      this.listOfReasons[i].value = this.listOfReasons[i].template_id
      this.listOfReasons[i].text = 'Template: ' + this.listOfReasons[i].name
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/documents/formSelectDocuments.vue